import { useLiveQuery } from 'dexie-react-hooks';
import { useWorkspace } from '@/app/providers/workspace-provider';
import type { Classification, Contact, TaskContact, Uuid } from '@/data/db';
import type { ClassificationTable } from '@/data/repositories/classification-repository';

export function useActiveContacts(): Contact[] | undefined {
  const { db } = useWorkspace();
  return useLiveQuery(async () => {
    const all = await db.contacts.orderBy('name').toArray();
    return all.filter((contact) => contact.deletedAt === null);
  }, [db]);
}

export function useClassifications(table: ClassificationTable): Classification[] | undefined {
  const { db } = useWorkspace();
  return useLiveQuery(() => db[table].orderBy('order').toArray(), [db, table]);
}

export function useTaskContacts(taskId: Uuid | null): TaskContact[] | undefined {
  const { db } = useWorkspace();
  return useLiveQuery(async () => {
    if (!taskId) return [];
    return db.taskContacts.where('taskId').equals(taskId).toArray();
  }, [db, taskId]);
}
